import { useCallback } from 'react';
import { Panel, PanelsLayout } from '@experiment-management-shared/types';

interface OnPanelAndLayoutChangeProps {
  chartId: string;
  panelChanges: Partial<Panel>;
  layoutChanges: Partial<PanelsLayout>;
}

interface BatchChartContainerGridHandlersProps {
  onPanelChange: (panelId: string, panel: Partial<Panel>) => void;
  onLayoutChange: (layout: PanelsLayout) => void;
  layout: PanelsLayout;
  onPanelAndLayoutChange: (changes: OnPanelAndLayoutChangeProps) => void;
}

const useBatchChartContainerGridHandlers = ({
  onPanelAndLayoutChange
}: BatchChartContainerGridHandlersProps) => {
  const finishEditing = useCallback(
    (layout, oldItem, newItem) => {
      if (newItem) {
        onPanelAndLayoutChange({
          chartId: newItem.i,
          panelChanges: {
            autoGenerated: false
          },
          layoutChanges: newItem
        });
      }
    },
    [onPanelAndLayoutChange]
  );

  return {
    onDragStop: finishEditing,
    onResizeStop: finishEditing
  };
};

export default useBatchChartContainerGridHandlers;
